import { Project } from '../domain/project/Project';
import { Supervisor } from '../domain/supervisor/Supervisor';
import { supervisorRepository } from '../repositories/supervisor';
import { SupervisorRepository } from '../repositories/supervisor/SupervisorRepository';

export class SupervisorService {
  constructor(private supervisorRepository: SupervisorRepository) {}
  async fetchSupervisor({ supervisorId }: { supervisorId: string }): Promise<Supervisor> {
    const supervisor = await this.supervisorRepository.fetch({ supervisorId });
    return supervisor;
  }
  async fetchAll({ project }: { project: Project }): Promise<Supervisor[]> {
    const response = await this.supervisorRepository.fetchAll({ project });
    return response;
  }
  async createSupervisors({
    supervisors,
    project,
  }: {
    supervisors: Supervisor[];
    project: Project;
  }): Promise<Supervisor[]> {
    const response = await this.supervisorRepository.createSupervisors({ supervisors, project });
    return response;
  }
  async save(supervisor: Supervisor, project: Project): Promise<Supervisor> {
    const response = await this.supervisorRepository.save(supervisor, project);
    return response;
  }
  async deleteSupervisors(supervisorIds: string[]): Promise<string[]> {
    await this.supervisorRepository.deleteSupervisors(supervisorIds);
    return supervisorIds;
  }
}

export const supervisorService = new SupervisorService(supervisorRepository);
